/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReferralCode = {
    /**
     * Referral ID
     */
    id?: string;
    /**
     * Referral code
     */
    code?: string;
    /**
     * User who owns this code
     */
    userId?: string;
    /**
     * Referral status (0=Active, 1=Disabled)
     */
    status?: ReferralCode.status;
    createdAt?: string;
    updatedAt?: string;
};
export namespace ReferralCode {
    /**
     * Referral status (0=Active, 1=Disabled)
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
    }
}

